import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import { MediumUp, MobileOnly } from 'src/ui/block';
import RatingSmiley from 'src/components/rating/smiley-rating';
import { RatingContainer } from './styles';

export const StoreRatingAverage: React.FC = () => {
  const { isFeatured = false, offer } = usePriceRowContext();
  const { store, rating } = offer;

  if (!store || !rating || rating.whole <= 0) {
    return null;
  }

  return (
    <RatingContainer data-rating={rating.roundedString}>
      <MobileOnly>
        <RatingSmiley
          featured={isFeatured}
          rating={rating}
          scoreVisibility="row"
          size="small"
        />
      </MobileOnly>

      <MediumUp>
        <RatingSmiley
          featured={isFeatured}
          rating={rating}
          scoreVisibility="row"
          size="small"
          reviewCount={store.userReviewSummary.countTotal}
        />
      </MediumUp>
    </RatingContainer>
  );
};
